import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  KeyValueDiffers,
  DoCheck
} from '@angular/core';
import { Polyline, Stroke } from '../../types';
import { SvgHelper } from '../../helpers/svghelper.service';

@Component({
  selector: 'g[svg-polyline]',
  templateUrl: './svgpolyline.component.html',
  styleUrls: ['./svgpolyline.component.css']
})
export class SvgPolylineComponent implements OnInit, DoCheck {
  differ: any;

  constructor(private differs: KeyValueDiffers, private svghelper: SvgHelper) {
    this.differ = this.differs.find({}).create();
  }

  @Input()
  public pointsString;

  @Input()
  public polyline: Polyline;

  @Output()
  public polylineMousedown = new EventEmitter<{
    mouseEvent: MouseEvent;
    polyline: Polyline;
  }>();

  ngOnInit() {
    if (this.polyline) {
      this.pointsString = this.svghelper.getPolyPoints(this.polyline.vertices);
    }
    if (!this.polyline.stroke) {
      this.polyline.stroke = new Stroke();
    }
  }

  ngDoCheck() {
    const changes = this.differ.diff(this.polyline);

    if (changes) {
      this.pointsString = this.svghelper.getPolyPoints(this.polyline.vertices);
    }
  }

  public onPolylineMouseDown(event): void {
    if (event) {
      this.polylineMousedown.emit({
        mouseEvent: event,
        polyline: this.polyline
      });
    }
  }
}
